import React from 'react'
import FormTitle from '../../../../components/FormTitle'
import Input from '../../../../components/FormInputs';
import DatePicker from '../../../../components/Datepicker';
import CustomDropDown from '../../../../components/Dropdown/CustomDropDown';
import { GenderOptions, MaritalStatusOptions } from '../../../../common/staticData';
interface PersonalDetailsProps {
    register: any;
    errors: any;
    setValue: any;
    data?: any;
}
const PersonalDetails: React.FC<PersonalDetailsProps> = ({ register, errors, setValue,data }) => {
  return (
    <div className="bg-white p-4 rounded-[20px] mt-2">
        <FormTitle title="Personal Details" />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-1">
            <DatePicker
                label="Date of Birth"
                onDateChange={(date: string) =>
                  setValue("personalDetails.dob", new Date(date))
                }
                register={register("personalDetails.dob")}
                name="personalDetails.dob"
                errors={errors}
                allowPastDates={true}
                includeTime={false}
                disabled={false}
                defaultValue={data?.personalDetails.dob}
                // defaultValue={dob}
              />
            <Input
                label="Blood Group"
                name="personalDetails.bloodGroup"
                errors={errors}
                register={register}
                placeholder="Enter your blood group"
                type="text"
            />
            <CustomDropDown
        label="Gender"
        name="personalDetails.gender"
        options={GenderOptions}
        register={register}
        errors={errors}
        placeholder="Select your Gender"
        defaultValue={data?.personalDetails?.gender}
        // onChange={(value) => console.log("Selected:", value)}
      />
            <CustomDropDown
        label="Marital Status"
        name="personalDetails.maritalStatus"
        options={MaritalStatusOptions}
        register={register}
        errors={errors}
        placeholder="Select your Gender"
        defaultValue={data?.personalDetails?.maritalStatus}
        // onChange={(value) => console.log("Selected:", value)}
      />
        </div>
    </div>
  )
}

export default PersonalDetails